<template>
  <aside
    v-show="innerVisible"
    class="screen-config-settings-panel"
    aria-label="Screen configuration"
  >
    <header class="sc-panel-header">
      <h2 class="sc-panel-title mb-0">Settings</h2>
      <div class="sc-panel-header-actions d-flex align-items-center">
        <b-form-checkbox
          v-model="innerEditMode"
          switch
          class="sc-edit-mode-toggle mb-0 mr-2"
          @change="onEditModeChange"
        >
          <span class="sc-edit-mode-label">Edit mode</span>
        </b-form-checkbox>
        <button
          type="button"
          class="sc-panel-close"
          aria-label="Close settings panel"
          title="Close"
          @click="closePanel"
        >
          ✕
        </button>
      </div>
    </header>

    <div class="sc-panel-body">
      <div v-if="draft && draft.screen" class="sc-panel-form">
        <p class="text-muted small mb-3">
          Advanced chart and layout settings. Turn on Edit mode to change titles
          inline on the dashboard.
        </p>

      <!-- Screen -->
<!--      <div class="sc-section-label">
      </div>-->
      <b-card v-if="draft.screen.screenlets.length>1" no-body class="sc-section sc-section-screen sc-set-acc mb-2">
        <b-card-header class="p-0">
          <b-button v-b-toggle.sc-set-screen block variant="link" class="sc-set-acc-btn text-left">
            Screen
          </b-button>
        </b-card-header>
        <b-collapse id="sc-set-screen" visible accordion="sc-set-acc">
          <b-card-body>
            <b-row>
              <b-col cols="12">
                <b-form-group label="screen_type" label-class="small text-muted mb-1">
                  <b-form-input v-model="draft.screen.screen_type" size="sm" />
                </b-form-group>
              </b-col>
            </b-row>
            <!--Screen listbox -->
            <hr class="my-2" />
            <h6 class="small text-muted mb-2">screen_listbox</h6>
            <b-form-group label="listbox_sql" label-class="small text-muted mb-1">
              <b-form-textarea v-model="draft.screen.screen_listbox.listbox_sql" rows="3" class="font-monospace small" />
            </b-form-group>
            <b-form-group label="filter_model" label-class="small text-muted mb-1">
              <b-form-select
                  v-model="draft.screen.screen_listbox.filter_model"
                  :options="filterModelOptions"
                  size="sm"
              />
            </b-form-group>
            <screen-config-filter-display-editor
              v-model="draft.screen.screen_listbox.filter_display"
              compact
            />

            <!-- screen date range filter& style -->
<!--            <b-form-checkbox v-model="draft.screen.date_range_filter_display" class="mb-2">
              date_range_filter_display
            </b-form-checkbox>
            <b-row>
              <b-col md="6">
                <b-form-group label="default_range" label-class="small text-muted mb-1">
                  <b-form-input v-model="draft.screen.date_range_filter_config.default_range" placeholder="last_30_days" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="allow_custom" label-class="small text-muted mb-1">
                  <b-form-checkbox v-model="draft.screen.date_range_filter_config.allow_custom">
                    Allow custom range
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="screen_card_style" label-class="small text-muted mb-1">
              <b-form-input v-model="draft.screen.screen_card_style" placeholder="null or CSS" />
            </b-form-group>
            <b-form-group label="orderby_text_json (JSON)" label-class="small text-muted mb-1">
              <b-form-textarea v-model="orderbyScreenJsonText" rows="2" class="font-monospace small" />
            </b-form-group>-->
          </b-card-body>
        </b-collapse>
      </b-card>

<!--      &lt;!&ndash; Screen listbox &ndash;&gt;
        <b-card no-body class="sc-set-acc mb-2">
        <b-card-header class="p-0">
          <b-button v-b-toggle.sc-set-screen-lb block variant="link" class="sc-set-acc-btn text-left">
            Screen — listbox
          </b-button>
        </b-card-header>
        <b-collapse id="sc-set-screen-lb" accordion="sc-set-acc">
          <b-card-body>
            <b-form-group label="listbox_sql" label-class="small text-muted mb-1">
              <b-form-textarea v-model="draft.screen.screen_listbox.listbox_sql" rows="3" class="font-monospace small" />
            </b-form-group>
            <b-form-group label="filter_model" label-class="small text-muted mb-1">
              <b-form-select
                v-model="draft.screen.screen_listbox.filter_model"
                :options="filterModelOptions"
              />
            </b-form-group>
            <screen-config-filter-display-editor v-model="draft.screen.screen_listbox.filter_display" />
          </b-card-body>
        </b-collapse>
      </b-card>

      &lt;!&ndash; Screen date & meta &ndash;&gt;
      <b-card no-body class="sc-section sc-section-screen sc-set-acc mb-2">
        <b-card-header class="p-0">
          <b-button v-b-toggle.sc-set-screen-meta block variant="link" class="sc-set-acc-btn text-left">
            Screen — date range &amp; style
          </b-button>
        </b-card-header>
        <b-collapse id="sc-set-screen-meta" accordion="sc-set-acc">
          <b-card-body>
            <b-form-checkbox v-model="draft.screen.date_range_filter_display" class="mb-2">
              date_range_filter_display
            </b-form-checkbox>
            <b-row>
              <b-col md="6">
                <b-form-group label="default_range" label-class="small text-muted mb-1">
                  <b-form-input v-model="draft.screen.date_range_filter_config.default_range" placeholder="last_30_days" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="allow_custom" label-class="small text-muted mb-1">
                  <b-form-checkbox v-model="draft.screen.date_range_filter_config.allow_custom">
                    Allow custom range
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="screen_card_style" label-class="small text-muted mb-1">
              <b-form-input v-model="draft.screen.screen_card_style" placeholder="null or CSS" />
            </b-form-group>
            <b-form-group label="orderby_text_json (JSON)" label-class="small text-muted mb-1">
              <b-form-textarea v-model="orderbyScreenJsonText" rows="2" class="font-monospace small" />
            </b-form-group>
          </b-card-body>
        </b-collapse>
      </b-card> -->

      <!-- Screenlet -->
      <template v-if="screenletDraft">
        <div class="sc-section-label">
          SCREENLET CONFIGURATION
        </div>
        <b-card no-body class="sc-section sc-section-screenlet sc-set-acc mb-2">
          <b-card-header class="p-0">
            <b-button v-b-toggle.sc-set-sl block variant="link" class="sc-set-acc-btn text-left">
              Screenlet
            </b-button>
          </b-card-header>
          <b-collapse id="sc-set-sl" accordion="sc-set-acc">
            <b-card-body>
              <b-row>
<!--                <b-col md="4">
                  <b-form-group label="screenlet_type" label-class="small text-muted mb-1">
                    <b-form-input v-model="screenletDraft.screenlet_type" />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="sequence" label-class="small text-muted mb-1">
                    <b-form-input v-model.number="screenletDraft.sequence" type="number" />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="addition_flag" label-class="small text-muted mb-1">
                    <b-form-checkbox v-model="screenletDraft.addition_flag" switch />
                  </b-form-group>
                </b-col>-->
                <b-col cols="12" v-if="draft.screen.screenlets.length>1">
                  <b-form-group label="default_count / max_count" label-class="small text-muted mb-1">
                    <div class="d-flex align-items-center sc-count-row">
                      <b-form-input
                        v-model.number="screenletDraft.default_count"
                        type="number"
                        size="sm"
                        class="mr-2"
                      />
                      <span class="mx-1 text-muted">/</span>
                      <b-form-input
                        v-model.number="screenletDraft.max_count"
                        type="number"
                        size="sm"
                      />
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr class="my-2" />
              <h6 class="small text-muted mb-2">screenlet_listbox</h6>
              <b-form-group label="listbox_sql" label-class="small text-muted mb-1">
                <b-form-textarea v-model="screenletDraft.screenlet_listbox.listbox_sql" rows="3" class="font-monospace small" />
              </b-form-group>
              <screen-config-filter-display-editor
                v-model="screenletDraft.screenlet_listbox.filter_display"
                compact
              />
<!--              <b-form-checkbox v-model="screenletDraft.date_range_filter_display" class="my-2">
                date_range_filter_display (screenlet)
              </b-form-checkbox>
              <b-row>
                <b-col md="6">
                  <b-form-group label="default_range" label-class="small text-muted mb-1">
                    <b-form-input v-model="screenletDraft.date_range_filter_config.default_range" />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-checkbox v-model="screenletDraft.date_range_filter_config.allow_custom" class="mt-4">
                    allow_custom
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-group label="screenlet_card_style" label-class="small text-muted mb-1">
                <b-form-input v-model="screenletDraft.screenlet_card_style" />
              </b-form-group>
              <b-form-group label="orderby_text_json (JSON)" label-class="small text-muted mb-1">
                <b-form-textarea v-model="orderbyScreenletJsonText" rows="2" class="font-monospace small" />
              </b-form-group>-->
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Vizlets -->
        <div class="sc-section-label">
          VIZLET CONFIGURATION
        </div>
        <div
          v-if="multiVizletEditMode && !drawerVizletEntries.length"
          class="sc-edit-empty"
        >
          Click a <strong>chart</strong> on the dashboard to edit its configuration.
        </div>
        <template v-for="entry in drawerVizletEntries">
          <div :key="'sc-vz-entry-' + entry.vi">
            <p v-if="multiVizletEditMode" class="sc-edit-hint">
              Vizlet {{ entry.vi + 1 }} — {{ entry.vz.vizlet_title || '(untitled)' }}
            </p>
        <b-card
          no-body
          class="sc-section sc-section-vizlet sc-set-acc mb-2"
          :class="{ 'border-0': multiVizletEditMode }"
        >
          <b-card-header v-if="!multiVizletEditMode && screenletDraft.vizlets.length > 1" class="p-0">
            <b-button
              v-b-toggle="'sc-set-vz-' + entry.vi"
              block
              variant="link"
              class="sc-set-acc-btn text-left"
            >
              Vizlet {{ entry.vi + 1 }} — {{ entry.vz.vizlet_title || '(untitled)' }}
            </b-button>
          </b-card-header>
          <b-collapse
            :id="'sc-set-vz-' + entry.vi"
            :visible="multiVizletEditMode || screenletDraft.vizlets.length <= 1"
            accordion="sc-set-acc"
          >
            <b-card-body>
              <b-card no-body class="border-0 mb-2 p-0 bg-transparent">
                <b-card-header class="p-0 border-0 bg-transparent">
                  <b-button v-b-toggle="'sc-vz-basic-' + entry.vi" block variant="outline-secondary" size="sm" class="text-left">
                    Basic
                  </b-button>
                </b-card-header>
                <b-collapse :id="'sc-vz-basic-' + entry.vi" visible :accordion="'sc-vz-inner-' + entry.vi">
                  <b-card-body class="pt-2 px-0 sc-vz-inner-body">
                    <b-row>
                      <b-col cols="12">
                        <b-form-group label="viztype_function_name" label-class="small text-muted mb-1">
                          <b-form-select
                            v-model="entry.vz.viztype_function_name"
                            :options="vizTypeSelectOptions"
                            size="sm"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="viztype_name" label-class="small text-muted mb-1">
                          <b-form-input v-model="entry.vz.viztype_name" size="sm" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="sequence" label-class="small text-muted mb-1">
                          <b-form-input v-model.number="entry.vz.sequence" type="number" size="sm" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Flags" label-class="small text-muted mb-1">
                          <div class="d-flex flex-wrap sc-flag-row">
                            <b-form-checkbox v-model="entry.vz.visible" class="mb-0 mr-3">visible</b-form-checkbox>
                            <b-form-checkbox v-model="entry.vz.scrollbar" class="mb-0 mr-3">scrollbar</b-form-checkbox>
                            <b-form-checkbox v-model="entry.vz.middle_title_flag" class="mb-0">middle_title_flag</b-form-checkbox>
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="card_style" label-class="small text-muted mb-1">
                          <b-form-input v-model="entry.vz.card_style" size="sm" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="border-0 mb-2 p-0 bg-transparent">
                <b-card-header class="p-0 border-0 bg-transparent">
                  <b-button v-b-toggle="'sc-vz-axis-' + entry.vi" block variant="outline-secondary" size="sm" class="text-left">
                    Axis &amp; metrics
                  </b-button>
                </b-card-header>
                <b-collapse :id="'sc-vz-axis-' + entry.vi" :accordion="'sc-vz-inner-' + entry.vi">
                  <b-card-body class="pt-2 px-0 sc-vz-inner-body">
                    <b-row>
                      <template v-for="fld in axisFields">
                        <b-col v-if="axisFieldVisible(entry.vi, fld)" :key="entry.vi + '-' + fld" cols="12">
                          <b-form-group :label="fld" label-class="small text-muted mb-1">
                            <b-form-input v-model="entry.vz.axis[fld]" size="sm" />
                          </b-form-group>
                        </b-col>
                      </template>
                    </b-row>
                    <b-form-group
                      v-if="hasVisibleVizSpecific(entry.vi)"
                      label="viz_specific1 … viz_specific7 (on axis)"
                      label-class="small text-muted mb-1"
                    >
                      <b-row>
                        <template v-for="n in 7">
                          <b-col
                            v-if="vizSpecificVisible(entry.vi, n)"
                            :key="'vs-' + entry.vi + '-' + n"
                            cols="12"
                            class="mb-1"
                          >
                            <span class="small text-muted">viz_specific{{ n }}</span>
                            <b-form-input v-model="entry.vz.axis['viz_specific' + n]" size="sm" class="font-monospace" />
                          </b-col>
                        </template>
                      </b-row>
                    </b-form-group>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="border-0 p-0 bg-transparent">
                <b-card-header class="p-0 border-0 bg-transparent">
                  <b-button v-b-toggle="'sc-vz-sql-' + entry.vi" block variant="outline-secondary" size="sm" class="text-left">
                    Data SQL
                  </b-button>
                </b-card-header>
                <b-collapse :id="'sc-vz-sql-' + entry.vi" :accordion="'sc-vz-inner-' + entry.vi">
                  <b-card-body class="pt-2 px-0 pb-0">
                    <b-form-group label="datasql" label-class="small text-muted mb-1">
                      <b-form-textarea v-model="entry.vz.datasql" rows="4" class="font-monospace small" />
                    </b-form-group>
                    <b-form-group label="download_sql" label-class="small text-muted mb-1">
                      <b-form-input v-model="entry.vz.download_sql" placeholder="optional id or empty" />
                    </b-form-group>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>
          </div>
        </template>
      </template>
      </div>
      <div v-else class="text-muted small">No configuration loaded.</div>
    </div>

    <footer class="sc-panel-footer">
      <b-button variant="outline-secondary" size="sm" @click="closePanel">Cancel</b-button>
      <b-button
        variant="primary"
        size="sm"
        :disabled="!draft || !draft.screen || saving"
        @click="onApply"
      >
        <b-spinner small v-if="saving" class="mr-1"></b-spinner>
        {{ saving ? 'Saving...' : 'Apply' }}
      </b-button>
    </footer>
  </aside>
</template>

<script>
import ScreenConfigFilterDisplayEditor from "@/components/screen_config_filter_display_editor.vue";
import axios from "axios";

const FILTER_MODEL_OPTS = [
  { value: "freeForm", text: "freeForm" },
  { value: "anyWhichWay", text: "anyWhichWay" },
];

export default {
  name: "ScreenConfigSettingsModal",
  components: { ScreenConfigFilterDisplayEditor },
  props: {
    visible: { type: Boolean, default: false },
    editMode: { type: Boolean, default: false },
    draft: { type: Object, default: null },
    vizTypeSelectOptions: {
      type: Array,
      default: () => [{ value: "", text: "(select)" }],
    },
    menuId: {
      type: String,
      required: true,
    },
    parentMenuId: {
      type: String,
      required: true,
    },
    updatedBy: {
      type: String,
      default: "admin",
    },
    selectedVizletIndex: {
      type: Number,
      default: null,
    },

  },
  data() {
    return {
      innerVisible: false,
      innerEditMode: false,
      saving: false,
      filterModelOptions: FILTER_MODEL_OPTS,
      layoutNumericKeys: [
        "chart_width",
        "chart_height",
        "pm_top",
        "pm_bottom",
        "pm_left",
        "pm_right",
        "axis_font_size",
        "axis_label_font_size",
        "axis_label_distance",
      ],
      layoutColorKeys: ["axis_font_color", "axis_label_font_color"],
      axisFields: [
        "x1_data_field_name",
        "x2_data_field_name",
        "y1_data_field_name",
        "y2_data_field_name",
        "x1_axis_display_name",
        "x2_axis_display_name",
        "y1_axis_display_name",
        "y2_axis_display_name",
        "x1_metric_tooltip",
        "x2_metric_tooltip",
        "y1_metric_tooltip",
        "y2_metric_tooltip",
        "legend_metric_tooltip",
        "y1_metric_unit",
        "y2_metric_unit",
        "colourscheme1",
        "number_system",
        "number_display_type",
        "high_low_better",
        "x1_d3scale_type",
        "y1_d3scale_type",
        "y2_d3scale_type",
      ],
      orderbyScreenJsonText: "{}",
      orderbyScreenletJsonText: "{}",
      visibleAxisFieldsByVizlet: {},
      visibleVizSpecificByVizlet: {},
      draftBaselineJson: null,
      forceClosing: false,
    };
  },
  computed: {
    screenletDraft() {
      const s = this.draft && this.draft.screen;
      if (!s || !Array.isArray(s.screenlets) || !s.screenlets.length) return null;
      return s.screenlets[0];
    },
    multiVizletEditMode() {
      return (
        this.innerEditMode
        && this.screenletDraft
        && Array.isArray(this.screenletDraft.vizlets)
        && this.screenletDraft.vizlets.length > 1
      );
    },
    effectiveVizletIndex() {
      const vizlets = this.screenletDraft && this.screenletDraft.vizlets;
      if (!vizlets || !vizlets.length) return -1;
      if (!this.multiVizletEditMode) return 0;
      if (this.selectedVizletIndex == null || this.selectedVizletIndex < 0) return -1;
      return Math.min(this.selectedVizletIndex, vizlets.length - 1);
    },
    selectedVizletDraft() {
      const i = this.effectiveVizletIndex;
      if (i < 0) return null;
      return this.screenletDraft.vizlets[i];
    },
    drawerVizletEntries() {
      const vizlets = (this.screenletDraft && this.screenletDraft.vizlets) || [];
      if (!vizlets.length) return [];
      if (this.multiVizletEditMode) {
        if (this.effectiveVizletIndex < 0) return [];
        const i = this.effectiveVizletIndex;
        return [{ vz: vizlets[i], vi: i }];
      }
      return vizlets.map((vz, vi) => ({ vz, vi }));
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(v, prev) {
        if (v) {
          this.innerVisible = true;
          this.innerEditMode = this.editMode;
          this.syncJsonFacades();
          this.$nextTick(() => {
            this.captureAxisFieldVisibility();
            this.captureDraftBaseline();
          });
          return;
        }
        if (this.forceClosing) {
          this.innerVisible = false;
          return;
        }
        if (prev) {
          this.innerVisible = true;
          this.attemptClose();
        }
      },
    },
    editMode: {
      immediate: true,
      handler(v) {
        if (this.innerVisible) this.innerEditMode = v;
      },
    },
    innerVisible(v) {
      if (v) this.$emit("update:visible", true);
    },
    draft: {
      deep: true,
      handler() {
        this.syncJsonFacades();
      },
    },
  },
  methods: {
    onEditModeChange() {
      this.$emit("update:editMode", this.innerEditMode);
      if (!this.innerEditMode) {
        this.$emit("update:selectedVizletIndex", null);
      }
    },
    captureDraftBaseline() {
      this.draftBaselineJson = this.serializeDraftState();
    },
    serializeDraftState() {
      return JSON.stringify({
        draft: this.draft ? JSON.parse(JSON.stringify(this.draft)) : null,
        orderbyScreenJsonText: this.orderbyScreenJsonText,
        orderbyScreenletJsonText: this.orderbyScreenletJsonText,
      });
    },
    isDraftDirty() {
      if (!this.draftBaselineJson) return false;
      return this.draftBaselineJson !== this.serializeDraftState();
    },
    confirmDiscardDraft() {
      return this.$bvModal.msgBoxConfirm(
        "If you leave this page, your recent edits will be lost",
        {
          title: "Discard changes?",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Discard",
          cancelTitle: "Keep editing",
          centered: true,
        },
      );
    },
    finishClose(emitDiscard) {
      this.forceClosing = true;
      this.draftBaselineJson = null;
      this.innerVisible = false;
      this.$emit("update:visible", false);
      this.innerEditMode = false;
      this.$emit("update:editMode", false);
      this.$emit("update:selectedVizletIndex", null);
      if (emitDiscard) this.$emit("discard");
      this.$nextTick(() => {
        this.forceClosing = false;
      });
    },
    attemptClose() {
      if (this.isDraftDirty()) {
        this.$emit("update:visible", true);
        this.confirmDiscardDraft().then((discard) => {
          if (discard) this.finishClose(true);
        });
        return;
      }
      this.finishClose(false);
    },
    closePanel() {
      this.attemptClose();
    },
    buildDisplayMetadataPayload() {
      const sc = this.draft && this.draft.screen;
      const sl = this.screenletDraft;
      const payload = { menuId: this.menuId };

      if (sc) {
        payload.screen = {
          title: sc.screen_title != null ? sc.screen_title : null,
          shortTitle:
            sc.screen_title_short != null ? sc.screen_title_short : null,
          info: sc.screen_title_info != null ? sc.screen_title_info : null,
        };
      }

      const screenlets = [];
      if (sl && sl.screenlet_instance_id) {
        screenlets.push({
          screenletInstanceId: sl.screenlet_instance_id,
          title: sl.title != null ? sl.title : null,
          shortTitle: sl.title_short != null ? sl.title_short : null,
          info: sl.title_info != null ? sl.title_info : null,
        });
      }
      payload.screenlets = screenlets;

      const vizlets = [];
      if (sl && Array.isArray(sl.vizlets)) {
        sl.vizlets.forEach((vz) => {
          const vizletId = vz.vizlet_id;
          const dataSqlId = vz.datasql_id;
          if (!vizletId || !dataSqlId) return;
          vizlets.push({
            vizletId,
            dataSqlId,
            title: vz.vizlet_title != null ? vz.vizlet_title : null,
            middleTitle:
              vz.vizlet_title_middle != null ? vz.vizlet_title_middle : null,
            shortTitle:
              vz.vizlet_title_short != null ? vz.vizlet_title_short : null,
            info: vz.vizlet_title_info != null ? vz.vizlet_title_info : null,
          });
        });
      }
      payload.vizlets = vizlets;
      return payload;
    },
    hasAxisValue(val) {
      if (val == null) return false;
      if (typeof val === "string") return val.trim() !== "";
      if (typeof val === "object") return Object.keys(val).length > 0;
      return true;
    },
    captureAxisFieldVisibility() {
      const sl = this.screenletDraft;
      if (!sl || !Array.isArray(sl.vizlets)) {
        this.visibleAxisFieldsByVizlet = {};
        this.visibleVizSpecificByVizlet = {};
        return;
      }

      const axisByViz = {};
      const specByViz = {};
      sl.vizlets.forEach((vz, vi) => {
        const axis = vz.axis || {};
        axisByViz[vi] = this.axisFields.filter((fld) =>
          this.hasAxisValue(axis[fld]),
        );
        specByViz[vi] = [];
        for (let n = 1; n <= 7; n += 1) {
          if (this.hasAxisValue(axis[`viz_specific${n}`])) {
            specByViz[vi].push(n);
          }
        }
      });
      this.visibleAxisFieldsByVizlet = axisByViz;
      this.visibleVizSpecificByVizlet = specByViz;
    },
    axisFieldVisible(vi, fld) {
      const fields = this.visibleAxisFieldsByVizlet[vi];
      return Array.isArray(fields) && fields.includes(fld);
    },
    vizSpecificVisible(vi, n) {
      const nums = this.visibleVizSpecificByVizlet[vi];
      return Array.isArray(nums) && nums.includes(n);
    },
    hasVisibleVizSpecific(vi) {
      const nums = this.visibleVizSpecificByVizlet[vi];
      return Array.isArray(nums) && nums.length > 0;
    },
    syncJsonFacades() {
      const sl = this.screenletDraft;
      if (!this.draft || !this.draft.screen) return;
      try {
        this.orderbyScreenJsonText = JSON.stringify(
          this.draft.screen.orderby_text_json || {},
          null,
          0,
        );
      } catch (e) {
        this.orderbyScreenJsonText = "{}";
      }
      if (sl) {
        try {
          this.orderbyScreenletJsonText = JSON.stringify(
            sl.orderby_text_json || {},
            null,
            0,
          );
        } catch (e) {
          this.orderbyScreenletJsonText = "{}";
        }
      }
    },
    vizunitWidthStr(vi) {
      const sl = this.screenletDraft;
      if (!sl || !sl.vizlets || !sl.vizlets[vi]) return "[]";
      try {
        return JSON.stringify(sl.vizlets[vi].layout.vizunit_width_array || []);
      } catch (e) {
        return "[]";
      }
    },
    onVizunitWidthInput(vi, ev) {
      const raw =
        typeof ev === "string" ? ev : ev && ev.target ? ev.target.value : "";
      const sl = this.screenletDraft;
      if (!sl || !sl.vizlets || !sl.vizlets[vi]) return;
      try {
        const parsed = JSON.parse(raw || "[]");
        if (Array.isArray(parsed)) {
          sl.vizlets[vi].layout.vizunit_width_array = parsed.map((n) => Number(n));
        }
      } catch (e) {
        /* invalid JSON — skip until valid */
      }
    },
    async onApply() {
      if (!this.draft || !this.draft.screen) return;

      try {
        this.saving = true;

        // Parse JSON facades
        try {
          this.draft.screen.orderby_text_json = JSON.parse(
              this.orderbyScreenJsonText || "{}",
          );
        } catch (e) {
          this.draft.screen.orderby_text_json = {};
        }

        const sl = this.screenletDraft;

        if (sl) {
          try {
            sl.orderby_text_json = JSON.parse(
                this.orderbyScreenletJsonText || "{}",
            );
          } catch (e) {
            sl.orderby_text_json = {};
          }
        }

        // Normalize null-ish values
        const NULLISH = /^(null|)$/i;

        if (
            this.draft.screen.screen_card_style !== undefined &&
            NULLISH.test(String(this.draft.screen.screen_card_style || "").trim())
        ) {
          this.draft.screen.screen_card_style = null;
        }

        if (
            sl &&
            sl.screenlet_card_style !== undefined &&
            NULLISH.test(String(sl.screenlet_card_style || "").trim())
        ) {
          sl.screenlet_card_style = null;
        }

        // Backend API call
        const payload = {
          menuId: this.menuId,
          parentMenuId: this.parentMenuId,
          updated_by: this.updatedBy,
          screen: this.draft.screen,
        };

        console.log("settings payload",payload)

        const metadataPayload = this.buildDisplayMetadataPayload();

        const [configResponse] = await Promise.all([
          axios.post("/api/sub-menu-config", payload),
          axios.post("/api/display-metadata", metadataPayload),
        ]);

        this.$bvToast.toast("Configuration updated successfully", {
          title: "Success",
          variant: "success",
          solid: true,
        });

        this.$emit("save", configResponse.data);

        this.finishClose(false);
      } catch (err) {
        console.error(err);

        this.$bvToast.toast(
            err?.response?.data?.message || "Failed to update configuration",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
        );
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
<style scoped>
/* Theme tokens — aligned with ConfigDashboard edit sidebar */
.screen-config-settings-panel {
  --dash-bg: #f4f6f9;
  --dash-surface: #ffffff;
  --dash-surface2: #f1f5f9;
  --dash-text: #1e293b;
  --dash-text-muted: #64748b;
  --dash-border: #e2e8f0;
  --dash-accent: #3b82f6;
  --dash-input-bg: #ffffff;
  --dash-input-border: #cbd5e1;
  --dash-shadow: rgba(0, 0, 0, 0.08);

  width: 300px;
  flex: 0 0 300px;
  max-width: 42vw;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  min-height: 0;
  z-index: 40;
  overflow: hidden;
  background: var(--dash-surface);
  border-left: 1px solid var(--dash-border);
  box-shadow: -6px 0 24px -8px var(--dash-shadow);
  color: var(--dash-text);
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  font-size: 0.85rem;
}

.sc-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 12px 14px;
  border-bottom: 1px solid var(--dash-border);
  background: var(--dash-surface);
  flex-shrink: 0;
}

.sc-panel-header-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.sc-edit-mode-toggle >>> .custom-control-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--dash-text-muted);
  padding-top: 1px;
}

.sc-edit-mode-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--dash-text-muted);
}

.sc-edit-mode-toggle >>> .custom-control-input:checked ~ .custom-control-label {
  color: var(--dash-accent);
}

.sc-edit-mode-toggle >>> .custom-control-input:checked ~ .custom-control-label::before {
  background-color: var(--dash-accent);
  border-color: var(--dash-accent);
}

.sc-panel-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: normal;
  text-transform: none;
  color: var(--dash-text);
}

.sc-panel-close {
  background: none;
  border: none;
  color: var(--dash-text-muted);
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
  padding: 4px 8px;
  margin: 0;
  border-radius: 4px;
  opacity: 1;
  text-shadow: none;
}

.sc-panel-close:hover {
  background: var(--dash-surface2);
  color: var(--dash-text);
}

.sc-panel-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 14px;
  text-align: left;
  -webkit-overflow-scrolling: touch;
}

.sc-panel-body >>> h6 {
  text-align: left;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--dash-text-muted);
}

.sc-panel-form {
  padding-bottom: 0;
  text-align: left;
}

.sc-panel-form > .text-muted.small {
  font-size: 0.72rem;
  color: var(--dash-text-muted) !important;
  line-height: 1.45;
  margin-bottom: 12px !important;
}

.screen-config-settings-panel >>> label,
.screen-config-settings-panel >>> legend,
.screen-config-settings-panel >>> .col-form-label {
  display: block;
  text-align: left !important;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--dash-text-muted);
  margin: 8px 0 4px 0;
}

.screen-config-settings-panel >>> .form-group {
  text-align: left;
  margin-bottom: 0;
}

.screen-config-settings-panel >>> .form-control,
.screen-config-settings-panel >>> .custom-select {
  width: 100%;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid var(--dash-input-border);
  background: var(--dash-input-bg);
  color: var(--dash-text);
  font-size: 0.85rem;
  box-sizing: border-box;
  height: auto;
  min-height: 34px;
}

.screen-config-settings-panel >>> .form-control:focus,
.screen-config-settings-panel >>> .custom-select:focus {
  outline: none;
  border-color: var(--dash-accent);
  box-shadow: none;
}

.screen-config-settings-panel >>> .form-control-sm,
.screen-config-settings-panel >>> .custom-select-sm {
  padding: 6px 10px;
  font-size: 0.85rem;
  min-height: 34px;
}

.screen-config-settings-panel >>> textarea.form-control {
  min-height: auto;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.8rem;
}

.screen-config-settings-panel >>> .custom-control-label {
  font-size: 0.82rem;
  color: var(--dash-text);
}

.screen-config-settings-panel >>> .custom-control-input {
  accent-color: var(--dash-accent);
}

.screen-config-settings-panel >>> hr {
  border-color: var(--dash-border);
  margin: 10px 0;
}

.sc-panel-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 14px;
  border-top: 1px solid var(--dash-border);
  background: var(--dash-surface);
  flex-shrink: 0;
}

.sc-panel-footer >>> .btn {
  height: 34px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.sc-panel-footer >>> .btn-outline-secondary {
  border: 1px solid var(--dash-border);
  background: var(--dash-surface);
  color: var(--dash-text);
}

.sc-panel-footer >>> .btn-outline-secondary:hover:not(:disabled) {
  background: var(--dash-surface2);
  border-color: var(--dash-border);
  color: var(--dash-text);
}

.sc-panel-footer >>> .btn-primary {
  border: 1px solid var(--dash-accent);
  background: var(--dash-accent);
  color: #fff;
}

.sc-panel-footer >>> .btn-primary:hover:not(:disabled) {
  background: color-mix(in srgb, var(--dash-accent) 88%, #000);
  border-color: color-mix(in srgb, var(--dash-accent) 88%, #000);
}

.sc-set-acc-btn {
  text-decoration: none !important;
  font-weight: 600;
  color: var(--dash-text) !important;
  padding: 8px 12px;
  font-size: 0.85rem;
  border-radius: 0;
}

.sc-set-acc-btn:focus {
  box-shadow: none !important;
}

.sc-set-acc-btn:hover {
  background: var(--dash-surface2);
  color: var(--dash-accent) !important;
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.sc-section {
  border-radius: 0;
  overflow: visible;
  border: none;
  background: transparent;
  margin-bottom: 14px !important;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--dash-border);
}

.sc-section >>> .card-header {
  background: transparent;
  border: none;
  padding: 0;
}

.sc-section >>> .card-body {
  padding: 8px 0 0 0;
}

.sc-section-screen,
.sc-section-screenlet,
.sc-section-vizlet {
  border-left: none;
  background: transparent;
}

.sc-section-label {
  margin: 0 0 10px 0;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--dash-text-muted);
  text-align: left;
}

.sc-edit-empty {
  color: var(--dash-text-muted);
  text-align: center;
  padding: 24px 8px 32px;
  font-size: 0.88rem;
  line-height: 1.5;
}

.sc-edit-hint {
  font-size: 0.75rem;
  color: var(--dash-accent);
  font-weight: 600;
  margin: 0 0 8px 0;
  text-transform: uppercase;
}

.sc-count-row >>> input {
  max-width: 5rem;
}

.sc-flag-row {
  gap: 6px 12px;
}

.sc-vz-inner-body {
  padding-bottom: 14px;
}

.sc-vz-inner-body >>> .form-group:last-child {
  margin-bottom: 4px;
}

.screen-config-settings-panel >>> .btn-outline-secondary.btn-sm {
  border: 1px solid var(--dash-border);
  background: var(--dash-surface2);
  color: var(--dash-text);
  font-size: 0.78rem;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 6px;
}

.screen-config-settings-panel >>> .btn-outline-secondary.btn-sm:hover,
.screen-config-settings-panel >>> .btn-outline-secondary.btn-sm:focus {
  background: color-mix(in srgb, var(--dash-accent) 8%, var(--dash-surface));
  border-color: var(--dash-accent);
  color: var(--dash-accent);
  box-shadow: none;
}

.screen-config-settings-panel >>> .inline-rich-text-editor .ql-toolbar {
  border-radius: 6px 6px 0 0;
  border-color: var(--dash-input-border);
}

.screen-config-settings-panel >>> .inline-rich-text-editor .ql-container {
  border-radius: 0 0 6px 6px;
  background: var(--dash-input-bg);
  border-color: var(--dash-input-border);
}

.screen-config-settings-panel >>> .table {
  color: var(--dash-text);
  font-size: 0.82rem;
}

.screen-config-settings-panel >>> .table thead th {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--dash-text-muted);
  background: var(--dash-surface2);
  border-color: var(--dash-border);
}

.screen-config-settings-panel >>> .table td,
.screen-config-settings-panel >>> .table th {
  border-color: var(--dash-border);
  vertical-align: middle;
}

.screen-config-settings-panel >>> .btn-outline-primary {
  border: 1px dashed var(--dash-accent);
  background: transparent;
  color: var(--dash-accent);
  font-size: 0.82rem;
  font-weight: 600;
}

.screen-config-settings-panel >>> .btn-outline-primary:hover {
  background: color-mix(in srgb, var(--dash-accent) 8%, transparent);
  border-style: solid;
  color: var(--dash-accent);
}

.screen-config-settings-panel >>> .btn-outline-danger {
  border: none;
  background: color-mix(in srgb, #ef4444 14%, transparent);
  color: #ef4444;
  font-size: 0.82rem;
  font-weight: 600;
}

.screen-config-settings-panel >>> .btn-outline-danger:hover {
  background: #ef4444;
  color: #fff;
}

@media (max-width: 900px) {
  .screen-config-settings-panel {
    flex: 0 0 300px;
    width: 300px;
    min-width: 260px;
  }
}

@media (max-width: 768px) {
  .screen-config-settings-panel {
    flex: 0 0 100%;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    max-height: 50vh;
    border-left: none;
    border-top: 1px solid var(--dash-border);
    box-shadow: none;
  }
}
</style>
